import StayDetails from './StayDetails';

export default StayDetails;
